import React from 'react';
import { Navbar } from '../../components/Navbar';
import { Footer } from '../../components/Footer';
import { PageHeroBanner } from '../../components/PageHeroBanner';
import { ServiceCTABanner } from '../../components/ServiceCTABanner';
import { CTAButton, CTABarOnBlue, MidPageCTAStrip } from '../../components/ServiceInlineCTA';
import { CheckCircleIcon, ArrowRightIcon, UsersIcon, WrenchIcon, LeafIcon, ClockIcon, DollarSignIcon, ThumbsUpIcon, HomeIcon, TrendingUpIcon, ShieldCheckIcon, SparklesIcon, DropletsIcon, SproutIcon, LayersIcon } from 'lucide-react';
const OTHER_SERVICES = [{
  name: 'Backyard Cleaning',
  slug: 'backyard-cleaning',
  img: 'https://cdn.magicpatterns.com/uploads/ahgarkrhWBWZi14WY7Vatg/lpw-service-backyard-cleaning-488x650.webp'
}, {
  name: 'Commercial Cleaning',
  slug: 'commercial-cleaning',
  img: 'https://cdn.magicpatterns.com/uploads/wNfvE2GAtkNAfy1MY4Qa6Y/bcpw-service-commercial-cleaning-576x1024.webp'
}, {
  name: 'Paver Cleaning',
  slug: 'paver-cleaning',
  img: 'https://cdn.magicpatterns.com/uploads/3MyhdEBmvuewzveVgi1yVk/lpw-service-paver-cleaning-488x650.webp'
}, {
  name: 'Solar Panel Cleaning',
  slug: 'solar-panel-cleaning',
  img: 'https://cdn.magicpatterns.com/uploads/7mkWmxZ6rJMX6ZT3SbVLdq/lpw-service-solar-panel-cleaning-577x1024.webp'
}, {
  name: 'Trash Can Cleaning',
  slug: 'trash-can-cleaning',
  img: 'https://cdn.magicpatterns.com/uploads/s8dNva1jhGj3tfrzpuizCn/lpw-service-trash-can-cleaning-488x650.webp'
}, {
  name: 'Window Cleaning',
  slug: 'window-cleaning',
  img: 'https://cdn.magicpatterns.com/uploads/4wiNEq1mR2Agh4kR5DHda3/lpw-service-window-cleaning-600x450.webp'
}];
const headingStyle = {
  color: '#0283C7',
  fontFamily: 'Montserrat, sans-serif',
  fontWeight: 900 as const,
  lineHeight: 1.2
};
const bodyStyle = {
  color: '#025A8A',
  fontFamily: 'Inter, sans-serif',
  fontSize: '16px',
  lineHeight: 1.8
};
const subHeadingStyle = {
  color: '#0283C7',
  fontFamily: 'Montserrat, sans-serif',
  fontWeight: 800 as const,
  lineHeight: 1.3
};
export function DrivewayCleaningPage() {
  return <div className="w-full min-h-screen" style={{
    fontFamily: 'Inter, sans-serif'
  }} data-id="element-1376">
      <Navbar data-id="element-1377" />
      <main data-id="element-1378">
        {/* Hero */}
        <PageHeroBanner eyebrow="Service" headline="Driveway Cleaning" subheadline="Our Driveway Cleaning services provide efficient, eco-friendly solutions to remove stains, oil, and debris, ensuring your driveway looks clean and well-kept. We use power washing and specialized cleaning methods tailored to your schedule, helping to maintain the beauty and longevity of your driveway." ctaPrimary={{
        label: 'Get A Free Quote',
        href: '#quote'
      }} ctaSecondary={{
        label: 'Contact Us',
        href: '#contact'
      }} data-id="element-1379" />

        {/* Section — Service Overview (Split Layout) */}
        <section className="w-full py-20 px-4" style={{
        backgroundColor: '#ffffff'
      }} data-id="element-1380">
          <div className="max-w-7xl mx-auto" data-id="element-1381">
            <div className="flex flex-col lg:flex-row items-start gap-12 lg:gap-16" data-id="element-1382">
              <div className="w-full lg:w-1/2" data-id="element-1383">
                <div className="rounded-2xl overflow-hidden" style={{
                boxShadow: '0 20px 60px rgba(2,131,199,0.15)'
              }} data-id="element-1384">
                  <img src="https://cdn.magicpatterns.com/uploads/u5rvnHTQ8C2zZ747ot3d8a/lpw-service-driveway-cleaning-488x650.webp" alt="Driveway Cleaning Service" className="w-full h-auto object-cover" style={{
                  maxHeight: '500px'
                }} data-id="element-1385" />
                </div>
              </div>
              <div className="w-full lg:w-1/2" data-id="element-1386">
                <h2 className="font-bold mb-6" style={{
                ...headingStyle,
                fontSize: 'clamp(24px, 4vw, 30px)'
              }} data-id="element-1387">
                  Driveway Cleaning Services: Restore the Look of Your Home's
                  Entrance
                </h2>
                <p className="mb-4" style={bodyStyle} data-id="element-1388">
                  Your driveway is one of the first things people notice when
                  approaching your home. Over time, it can accumulate dirt, oil
                  stains, mold, mildew, tire marks, and other debris that make
                  it look worn and neglected. Our professional driveway cleaning
                  service is designed to restore your driveway's appearance,
                  enhancing your home's curb appeal and ensuring it's safe to
                  use.
                </p>
                <p style={bodyStyle} data-id="element-1389">
                  Our driveway cleaning service goes beyond a simple rinse. We
                  use advanced pressure washing techniques and environmentally
                  friendly cleaning solutions to deeply clean your driveway,
                  removing years of built-up grime. Whether your driveway is
                  made of concrete, asphalt, brick, or pavers, we have the
                  expertise to clean it effectively without causing damage.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Inline CTA */}
        <CTAButton data-id="element-1390" />

        {/* Section — Comprehensive Services */}
        <section className="w-full py-20 px-4" style={{
        backgroundColor: '#E8F4FD'
      }} data-id="element-1391">
          <div className="max-w-7xl mx-auto" data-id="element-1392">
            <h2 className="font-bold text-center mb-4" style={{
            ...headingStyle,
            fontSize: 'clamp(24px, 4vw, 32px)'
          }} data-id="element-1393">
              Comprehensive Driveway Cleaning
            </h2>
            <p className="text-center mb-14 max-w-3xl mx-auto" style={bodyStyle} data-id="element-1394">
              Here's a breakdown of what our driveway cleaning service includes:
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-1395">
              <div className="p-8 rounded-2xl bg-white" style={{
              boxShadow: '0 4px 20px rgba(2,131,199,0.08)'
            }} data-id="element-1396">
                <div className="flex items-center gap-4 mb-4" data-id="element-1397">
                  <div className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0" style={{
                  backgroundColor: '#0283C7'
                }} data-id="element-1398">
                    <span className="text-white font-bold text-sm" style={{
                    fontFamily: 'Montserrat, sans-serif'
                  }} data-id="element-1399">
                      1
                    </span>
                  </div>
                  <h3 className="font-bold" style={{
                  ...subHeadingStyle,
                  fontSize: '17px'
                }} data-id="element-1400">
                    High-Pressure Washing
                  </h3>
                </div>
                <p style={{
                ...bodyStyle,
                fontSize: '15px'
              }} data-id="element-1401">
                  Our team uses powerful pressure washing equipment to blast
                  away dirt, algae, mold, and mildew that accumulate on your
                  driveway's surface. This deep cleaning process helps restore
                  the original color and texture of the material, whether it's
                  concrete, brick, or asphalt. We adjust the pressure settings
                  to match the specific type of driveway to ensure a thorough
                  clean without any risk of damage.
                </p>
              </div>

              <div className="p-8 rounded-2xl bg-white" style={{
              boxShadow: '0 4px 20px rgba(2,131,199,0.08)'
            }} data-id="element-1402">
                <div className="flex items-center gap-4 mb-4" data-id="element-1403">
                  <div className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0" style={{
                  backgroundColor: '#0283C7'
                }} data-id="element-1404">
                    <span className="text-white font-bold text-sm" style={{
                    fontFamily: 'Montserrat, sans-serif'
                  }} data-id="element-1405">
                      2
                    </span>
                  </div>
                  <h3 className="font-bold" style={{
                  ...subHeadingStyle,
                  fontSize: '17px'
                }} data-id="element-1406">
                    Oil and Stain Removal
                  </h3>
                </div>
                <p style={{
                ...bodyStyle,
                fontSize: '15px'
              }} data-id="element-1407">
                  Driveways often suffer from oil leaks, grease spills, and tire
                  marks that leave unsightly stains. These can be tough to
                  remove with standard cleaning methods, but our service
                  includes specialized cleaning agents designed to break down
                  and lift stubborn oil and grease stains. We target areas that
                  have been stained over time, ensuring a fresh and uniform
                  appearance.
                </p>
              </div>

              <div className="p-8 rounded-2xl bg-white" style={{
              boxShadow: '0 4px 20px rgba(2,131,199,0.08)'
            }} data-id="element-1408">
                <div className="flex items-center gap-4 mb-4" data-id="element-1409">
                  <div className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0" style={{
                  backgroundColor: '#0283C7'
                }} data-id="element-1410">
                    <span className="text-white font-bold text-sm" style={{
                    fontFamily: 'Montserrat, sans-serif'
                  }} data-id="element-1411">
                      3
                    </span>
                  </div>
                  <h3 className="font-bold" style={{
                  ...subHeadingStyle,
                  fontSize: '17px'
                }} data-id="element-1412">
                    Mold, Mildew, and Algae Treatment
                  </h3>
                </div>
                <p style={{
                ...bodyStyle,
                fontSize: '15px'
              }} data-id="element-1413">
                  In damp or shaded areas, mold, mildew, and algae can grow on
                  your driveway's surface, making it slippery and unsafe to walk
                  or drive on. We apply eco-friendly treatments that kill and
                  prevent these harmful growths, leaving your driveway clean and
                  safe for use.
                </p>
              </div>

              <div className="p-8 rounded-2xl bg-white" style={{
              boxShadow: '0 4px 20px rgba(2,131,199,0.08)'
            }} data-id="element-1414">
                <div className="flex items-center gap-4 mb-4" data-id="element-1415">
                  <div className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0" style={{
                  backgroundColor: '#0283C7'
                }} data-id="element-1416">
                    <span className="text-white font-bold text-sm" style={{
                    fontFamily: 'Montserrat, sans-serif'
                  }} data-id="element-1417">
                      4
                    </span>
                  </div>
                  <h3 className="font-bold" style={{
                  ...subHeadingStyle,
                  fontSize: '17px'
                }} data-id="element-1418">
                    Crack and Weed Cleaning
                  </h3>
                </div>
                <p style={{
                ...bodyStyle,
                fontSize: '15px'
              }} data-id="element-1419">
                  Weeds growing through cracks in your driveway can lead to
                  further damage and make your driveway look untidy. As part of
                  our driveway cleaning service, we clear away weeds, dirt, and
                  debris from cracks and crevices, helping prevent them from
                  growing back and protecting your driveway from further damage.
                </p>
              </div>

              <div className="p-8 rounded-2xl bg-white" style={{
              boxShadow: '0 4px 20px rgba(2,131,199,0.08)'
            }} data-id="element-1420">
                <div className="flex items-center gap-4 mb-4" data-id="element-1421">
                  <div className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0" style={{
                  backgroundColor: '#0283C7'
                }} data-id="element-1422">
                    <span className="text-white font-bold text-sm" style={{
                    fontFamily: 'Montserrat, sans-serif'
                  }} data-id="element-1423">
                      5
                    </span>
                  </div>
                  <h3 className="font-bold" style={{
                  ...subHeadingStyle,
                  fontSize: '17px'
                }} data-id="element-1424">
                    Surface Sealing (Optional)
                  </h3>
                </div>
                <p style={{
                ...bodyStyle,
                fontSize: '15px'
              }} data-id="element-1425">
                  After cleaning, we offer an optional sealing service to
                  protect your driveway from future staining and weather damage.
                  A high-quality sealant not only extends the life of your
                  driveway but also keeps it looking cleaner for longer by
                  preventing dirt, oil, and grime from penetrating the surface.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Inline CTA Bar */}
        <CTABarOnBlue data-id="element-1426" />

        {/* Section — Why Choose Us */}
        <section className="w-full py-20 px-4" style={{
        backgroundColor: '#ffffff'
      }} data-id="element-1427">
          <div className="max-w-7xl mx-auto" data-id="element-1428">
            <h2 className="font-bold text-center mb-14" style={{
            ...headingStyle,
            fontSize: 'clamp(24px, 4vw, 32px)'
          }} data-id="element-1429">
              Why Choose Our Driveway Cleaning Service?
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-1430">
              <div className="bg-[#E8F4FD] text-center p-8 rounded-2xl" data-id="element-1431">
                <div className="w-14 h-14 rounded-full flex items-center justify-center mx-auto mb-5" style={{
                backgroundColor: '#0283C7'
              }} data-id="element-1432">
                  <UsersIcon className="h-6 w-6 text-white" data-id="element-1433" />
                </div>
                <h3 className="font-bold mb-3" style={{
                ...subHeadingStyle,
                fontSize: '17px'
              }} data-id="element-1434">
                  Experienced Professionals
                </h3>
                <p style={{
                ...bodyStyle,
                fontSize: '14px'
              }} data-id="element-1435">
                  Our trained technicians know how to handle different driveway
                  materials, ensuring a safe and effective clean every time.
                </p>
              </div>

              <div className="bg-[#E8F4FD] text-center p-8 rounded-2xl" data-id="element-1436">
                <div className="w-14 h-14 rounded-full flex items-center justify-center mx-auto mb-5" style={{
                backgroundColor: '#0283C7'
              }} data-id="element-1437">
                  <WrenchIcon className="h-6 w-6 text-white" data-id="element-1438" />
                </div>
                <h3 className="font-bold mb-3" style={{
                ...subHeadingStyle,
                fontSize: '17px'
              }} data-id="element-1439">
                  State-of-the-Art Equipment
                </h3>
                <p style={{
                ...bodyStyle,
                fontSize: '14px'
              }} data-id="element-1440">
                  We use industrial-grade pressure washers and high-quality
                  cleaning solutions to provide the best possible results.
                </p>
              </div>

              <div className="bg-[#E8F4FD] text-center p-8 rounded-2xl" data-id="element-1441">
                <div className="w-14 h-14 rounded-full flex items-center justify-center mx-auto mb-5" style={{
                backgroundColor: '#0283C7'
              }} data-id="element-1442">
                  <LeafIcon className="h-6 w-6 text-white" data-id="element-1443" />
                </div>
                <h3 className="font-bold mb-3" style={{
                ...subHeadingStyle,
                fontSize: '17px'
              }} data-id="element-1444">
                  Eco-Friendly Solutions
                </h3>
                <p style={{
                ...bodyStyle,
                fontSize: '14px'
              }} data-id="element-1445">
                  Our cleaning products are environmentally safe, so you don't
                  have to worry about harmful chemicals affecting your lawn,
                  garden, or the surrounding environment.
                </p>
              </div>

              <div className="bg-[#E8F4FD] text-center p-8 rounded-2xl" data-id="element-1446">
                <div className="w-14 h-14 rounded-full flex items-center justify-center mx-auto mb-5" style={{
                backgroundColor: '#0283C7'
              }} data-id="element-1447">
                  <ClockIcon className="h-6 w-6 text-white" data-id="element-1448" />
                </div>
                <h3 className="font-bold mb-3" style={{
                ...subHeadingStyle,
                fontSize: '17px'
              }} data-id="element-1449">
                  Fast and Efficient
                </h3>
                <p style={{
                ...bodyStyle,
                fontSize: '14px'
              }} data-id="element-1450">
                  We respect your time and schedule. Our team works efficiently
                  to complete the cleaning quickly, so you can get back to
                  enjoying your clean driveway without delays.
                </p>
              </div>

              <div className="bg-[#E8F4FD] text-center p-8 rounded-2xl" data-id="element-1451">
                <div className="w-14 h-14 rounded-full flex items-center justify-center mx-auto mb-5" style={{
                backgroundColor: '#0283C7'
              }} data-id="element-1452">
                  <DollarSignIcon className="h-6 w-6 text-white" data-id="element-1453" />
                </div>
                <h3 className="font-bold mb-3" style={{
                ...subHeadingStyle,
                fontSize: '17px'
              }} data-id="element-1454">
                  Affordable Pricing
                </h3>
                <p style={{
                ...bodyStyle,
                fontSize: '14px'
              }} data-id="element-1455">
                  We offer competitive rates for driveway cleaning, giving you
                  excellent value for a top-quality service.
                </p>
              </div>

              <div className="bg-[#E8F4FD] text-center p-8 rounded-2xl" data-id="element-1456">
                <div className="w-14 h-14 rounded-full flex items-center justify-center mx-auto mb-5" style={{
                backgroundColor: '#0283C7'
              }} data-id="element-1457">
                  <ThumbsUpIcon className="h-6 w-6 text-white" data-id="element-1458" />
                </div>
                <h3 className="font-bold mb-3" style={{
                ...subHeadingStyle,
                fontSize: '17px'
              }} data-id="element-1459">
                  Customer Satisfaction Guarantee
                </h3>
                <p style={{
                ...bodyStyle,
                fontSize: '14px'
              }} data-id="element-1460">
                  We're committed to ensuring every customer is satisfied with
                  the results of our service. If you're not happy with the
                  outcome, we'll make it right.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Inline CTA */}
        <CTAButton data-id="element-1461" />

        {/* Section — Benefits */}
        <section className="w-full py-20 px-4" style={{
        backgroundColor: '#E8F4FD'
      }} data-id="element-1462">
          <div className="max-w-7xl mx-auto" data-id="element-1463">
            <h2 className="font-bold text-center mb-14" style={{
            ...headingStyle,
            fontSize: 'clamp(24px, 4vw, 32px)'
          }} data-id="element-1464">
              Benefits of Professional Driveway Cleaning
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-1465">
              <div className="flex gap-5" data-id="element-1466">
                <div className="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0 bg-white" style={{
                boxShadow: '0 4px 12px rgba(2,131,199,0.1)'
              }} data-id="element-1467">
                  <HomeIcon className="h-6 w-6" style={{
                  color: '#0283C7'
                }} data-id="element-1468" />
                </div>
                <div data-id="element-1469">
                  <h3 className="font-bold mb-2" style={{
                  ...subHeadingStyle,
                  fontSize: '18px'
                }} data-id="element-1470">
                    Boost Curb Appeal
                  </h3>
                  <p style={{
                  ...bodyStyle,
                  fontSize: '15px'
                }} data-id="element-1471">
                    A clean, well-maintained driveway enhances the overall
                    appearance of your home, giving it a fresh, polished look.
                  </p>
                </div>
              </div>

              <div className="flex gap-5" data-id="element-1472">
                <div className="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0 bg-white" style={{
                boxShadow: '0 4px 12px rgba(2,131,199,0.1)'
              }} data-id="element-1473">
                  <TrendingUpIcon className="h-6 w-6" style={{
                  color: '#0283C7'
                }} data-id="element-1474" />
                </div>
                <div data-id="element-1475">
                  <h3 className="font-bold mb-2" style={{
                  ...subHeadingStyle,
                  fontSize: '18px'
                }} data-id="element-1476">
                    Increase Property Value
                  </h3>
                  <p style={{
                  ...bodyStyle,
                  fontSize: '15px'
                }} data-id="element-1477">
                    Regular maintenance and cleaning help preserve the integrity
                    of your driveway, potentially increasing your home's resale
                    value.
                  </p>
                </div>
              </div>

              <div className="flex gap-5" data-id="element-1478">
                <div className="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0 bg-white" style={{
                boxShadow: '0 4px 12px rgba(2,131,199,0.1)'
              }} data-id="element-1479">
                  <ShieldCheckIcon className="h-6 w-6" style={{
                  color: '#0283C7'
                }} data-id="element-1480" />
                </div>
                <div data-id="element-1481">
                  <h3 className="font-bold mb-2" style={{
                  ...subHeadingStyle,
                  fontSize: '18px'
                }} data-id="element-1482">
                    Improve Safety
                  </h3>
                  <p style={{
                  ...bodyStyle,
                  fontSize: '15px'
                }} data-id="element-1483">
                    Mold, mildew, and algae can make driveways slippery and
                    dangerous. Regular cleaning ensures that your driveway is
                    safe for family and guests to walk and drive on.
                  </p>
                </div>
              </div>

              <div className="flex gap-5" data-id="element-1484">
                <div className="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0 bg-white" style={{
                boxShadow: '0 4px 12px rgba(2,131,199,0.1)'
              }} data-id="element-1485">
                  <WrenchIcon className="h-6 w-6" style={{
                  color: '#0283C7'
                }} data-id="element-1486" />
                </div>
                <div data-id="element-1487">
                  <h3 className="font-bold mb-2" style={{
                  ...subHeadingStyle,
                  fontSize: '18px'
                }} data-id="element-1488">
                    Prevent Long-Term Damage
                  </h3>
                  <p style={{
                  ...bodyStyle,
                  fontSize: '15px'
                }} data-id="element-1489">
                    Dirt, oil, and debris can penetrate driveway surfaces and
                    lead to cracks or other damage. Routine cleaning helps
                    prevent these issues, extending the life of your driveway.
                  </p>
                </div>
              </div>

              <div className="flex gap-5 md:col-span-2 md:max-w-lg md:mx-auto" data-id="element-1490">
                <div className="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0 bg-white" style={{
                boxShadow: '0 4px 12px rgba(2,131,199,0.1)'
              }} data-id="element-1491">
                  <ClockIcon className="h-6 w-6" style={{
                  color: '#0283C7'
                }} data-id="element-1492" />
                </div>
                <div data-id="element-1493">
                  <h3 className="font-bold mb-2" style={{
                  ...subHeadingStyle,
                  fontSize: '18px'
                }} data-id="element-1494">
                    Save Time and Effort
                  </h3>
                  <p style={{
                  ...bodyStyle,
                  fontSize: '15px'
                }} data-id="element-1495">
                    Cleaning a driveway can be a labor-intensive task. Letting
                    professionals handle it saves you time, energy, and the
                    hassle of dealing with stubborn stains and dirt.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Mid-Page CTA Strip */}
        <MidPageCTAStrip data-id="element-1496" />

        {/* Section — Materials We Clean */}
        <section className="w-full py-20 px-4" style={{
        backgroundColor: '#ffffff'
      }} data-id="element-1497">
          <div className="max-w-7xl mx-auto" data-id="element-1498">
            <h2 className="font-bold text-center mb-12" style={{
            ...headingStyle,
            fontSize: 'clamp(24px, 4vw, 32px)'
          }} data-id="element-1499">
              Driveway Materials We Clean
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-1500">
              <div className="p-6 rounded-2xl border" style={{
              borderColor: '#E8F4FD',
              boxShadow: '0 4px 20px rgba(2,131,199,0.05)'
            }} data-id="element-1501">
                <h3 className="font-bold mb-3" style={{
                ...subHeadingStyle,
                fontSize: '18px'
              }} data-id="element-1502">
                  Concrete Driveways
                </h3>
                <p style={{
                ...bodyStyle,
                fontSize: '14px'
              }} data-id="element-1503">
                  Our pressure washing service removes surface stains, mold, and
                  grime, restoring the bright, clean appearance of concrete.
                </p>
              </div>
              <div className="p-6 rounded-2xl border" style={{
              borderColor: '#E8F4FD',
              boxShadow: '0 4px 20px rgba(2,131,199,0.05)'
            }} data-id="element-1504">
                <h3 className="font-bold mb-3" style={{
                ...subHeadingStyle,
                fontSize: '18px'
              }} data-id="element-1505">
                  Asphalt Driveways
                </h3>
                <p style={{
                ...bodyStyle,
                fontSize: '14px'
              }} data-id="element-1506">
                  We use appropriate pressure and cleaning solutions to safely
                  clean asphalt without causing cracks or erosion.
                </p>
              </div>
              <div className="p-6 rounded-2xl border" style={{
              borderColor: '#E8F4FD',
              boxShadow: '0 4px 20px rgba(2,131,199,0.05)'
            }} data-id="element-1507">
                <h3 className="font-bold mb-3" style={{
                ...subHeadingStyle,
                fontSize: '18px'
              }} data-id="element-1508">
                  Brick and Paver Driveways
                </h3>
                <p style={{
                ...bodyStyle,
                fontSize: '14px'
              }} data-id="element-1509">
                  We clean in between the cracks and joints of brick and paver
                  driveways, eliminating weeds, dirt, and moss for a spotless
                  finish.
                </p>
              </div>
              <div className="p-6 rounded-2xl border" style={{
              borderColor: '#E8F4FD',
              boxShadow: '0 4px 20px rgba(2,131,199,0.05)'
            }} data-id="element-1510">
                <h3 className="font-bold mb-3" style={{
                ...subHeadingStyle,
                fontSize: '18px'
              }} data-id="element-1511">
                  Gravel Driveways
                </h3>
                <p style={{
                ...bodyStyle,
                fontSize: '14px'
              }} data-id="element-1512">
                  Though more delicate, gravel driveways can also be cleaned to
                  remove dirt and debris, improving their appearance without
                  disrupting the gravel itself.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Section — Why Regular Cleaning is Essential */}
        <section className="w-full py-20 px-4" style={{
        backgroundColor: '#E8F4FD'
      }} data-id="element-1513">
          <div className="max-w-4xl mx-auto text-center" data-id="element-1514">
            <h2 className="font-bold mb-6" style={{
            ...headingStyle,
            fontSize: 'clamp(24px, 4vw, 32px)'
          }} data-id="element-1515">
              Why Regular Driveway Cleaning is Essential
            </h2>
            <p className="mb-6" style={bodyStyle} data-id="element-1516">
              Driveways take a lot of abuse from vehicles, weather, and everyday
              wear and tear. Without regular cleaning, grime can build up,
              creating a breeding ground for bacteria and mildew. Oil stains and
              dirt can also erode the surface, leading to cracks and potholes
              over time. Routine driveway cleaning helps to protect your
              investment, ensuring it remains in excellent condition for years
              to come.
            </p>
            <p style={bodyStyle} data-id="element-1517">
              Let us take care of your driveway and bring back its original
              shine! Our exterior cleaning service is designed to leave your
              driveway spotless, safe, and looking like new.
            </p>
          </div>
        </section>

        {/* Section — Other Services */}
        <section className="w-full py-20 px-4" style={{
        backgroundColor: '#ffffff'
      }} data-id="element-1518">
          <div className="max-w-7xl mx-auto" data-id="element-1519">
            <h2 className="font-bold text-center mb-12" style={{
            ...headingStyle,
            fontSize: 'clamp(24px, 4vw, 30px)'
          }} data-id="element-1520">
              Explore Our Other Services
            </h2>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4" data-id="element-1521">
              {OTHER_SERVICES.map(service => <a key={service.slug} href={`/services/${service.slug}`} className="bg-white rounded-xl p-5 text-center transition-all hover:shadow-lg hover:scale-[1.02] flex flex-col items-center gap-3 border" style={{
              boxShadow: '0 2px 12px rgba(2,131,199,0.08)',
              borderColor: '#E8F4FD'
            }} data-id="element-1522">
                  <div className="w-14 h-14 rounded-full overflow-hidden flex-shrink-0" style={{
                backgroundColor: '#E8F4FD'
              }} data-id="element-1523">
                    <img src={service.img} alt={service.name} className="w-full h-full object-cover" data-id="element-1524" />
                  </div>
                  <p className="font-bold text-sm" style={{
                color: '#0283C7',
                fontFamily: 'Montserrat, sans-serif',
                fontSize: '13px'
              }} data-id="element-1525">
                    {service.name}
                  </p>
                  <span className="flex items-center gap-1 text-xs font-semibold" style={{
                color: '#0283C7',
                fontFamily: 'Inter, sans-serif'
              }} data-id="element-1526">
                    Learn More <ArrowRightIcon className="h-3 w-3" data-id="element-1527" />
                  </span>
                </a>)}
            </div>
          </div>
        </section>

        {/* CTA Banner */}
        <ServiceCTABanner headline="Ready to Restore Your Driveway?" data-id="element-1528" />
      </main>
      <Footer data-id="element-1529" />
    </div>;
}